import { render, staticRenderFns } from "./FTMVaultBox.vue?vue&type=template&id=546df52b&"
import script from "./FTMVaultBox.vue?vue&type=script&lang=js&"
export * from "./FTMVaultBox.vue?vue&type=script&lang=js&"
import style0 from "./FTMVaultBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports